/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 40, height = 28, fill = "none" }) => (
  <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon=credit-card">
      <path id="Vector" d="M2 10.4603H22M4 5.46033H20C21.1046 5.46033 22 6.35576 22 7.46033V17.4603C22 18.5649 21.1046 19.4603 20 19.4603H4C2.89543 19.4603 2 18.5649 2 17.4603V7.46033C2 6.35576 2.89543 5.46033 4 5.46033Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  </svg>
);

export default SvgComponent;
